import { environment } from '@env/environment';
import { BaseObject } from '@adgate/common/types/base-object.type';
import { BaseService } from '@adgate/common/services/base-service';
import { Service } from '@angular/core';

@Service()
export class CommonObjectService extends BaseService
{
    private baseServiceUrl = `${environment.baseServiceUrl}common`;

    getMainNotifications()
    {
        let url = `${this.baseServiceUrl}/getMainNotifications`;
        return this.sendRequest(url, null, 'get');
    }

    getCommercialTypes(usage: number)
    {
        let url = `${this.baseServiceUrl}/getCommercialTypes/${usage}`;
        return this.sendRequest(url, null, 'get');
    }

    getCommercialTypesByFamily(families: BaseObject[])
    {
        let url = `${this.baseServiceUrl}/getCommercialTypesByFamily`;
        return this.sendRequest(url, families,'post');
    }

    getCategories()
    {
        let url = `${this.baseServiceUrl}/getCategories`;
        return this.sendRequest(url, null, 'get');
    }

    getCommercialAttributes()
    {
        let url = `${this.baseServiceUrl}/getCommercialAttributes`;
        return this.sendRequest(url, null, 'get');
    }

    getLanguages()
    {
        let url = `${this.baseServiceUrl}/getLanguages`;
        return this.sendRequest(url, null, 'get');
    }

    getBrands(agencyId: number | null)
    {
        let url = `${this.baseServiceUrl}/getBrands${agencyId ? `?agencyId=${agencyId}` : ''}`;
        return this.sendRequest(url, null, 'get');
    }

    getProducts(agencyId: number | null)
    {
        let url = `${this.baseServiceUrl}/getProducts${agencyId ? `?agencyId=${agencyId}` : ''}`;
        return this.sendRequest(url, null, 'get');
    }

    getCommercialOffices(agencyId: number | null)
    {
        let url = `${this.baseServiceUrl}/getCommercialOffices${agencyId ? `?agencyId=${agencyId}` : ''}`;
        return this.sendRequest(url, null, 'get');
    }

    getAgencies(officeId: number | null)
    {
        let url = `${this.baseServiceUrl}/getAgencies${officeId ? `?officeId=${officeId}` : ''}`;
        return this.sendRequest(url, null, 'get');
    }

    getChannelFamilies( usage: number )
    {
        let url = `${this.baseServiceUrl}/getChannelFamilies/${usage}`;
        return this.sendRequest(url, null, 'get');
    }

    getStatuses( objectType: number )
    {
        let url = `${this.baseServiceUrl}/getStatuses/${objectType}`;
        return this.sendRequest(url, null, 'get');
    }

    getObjectHistory( objectType: number, objectId: number )
    {
        let url = `${this.baseServiceUrl}/getObjectHistory/${objectType}/${objectId}`;
        return this.sendRequest(url, null, 'get');
    }

    getObjectSpecErrorReport( objectType: number, objectId: number )
    {
        let url = `${this.baseServiceUrl}/getObjectSpecErrorReport/${objectType}/${objectId}`;
        return this.sendRequest(url, null, 'get');
    }

    getCountries()
    {
        let url = `${this.baseServiceUrl}/getCountries`;
        return this.sendRequest(url, null, 'get');
    }

    addObjectHistory( objectType: number, objectId: number[], userName: string, message: string, messageType: number, sendMail: boolean = false, mailGroups: BaseObject[] = [], sendExternalNotification: boolean = false )
    {
        let payload: any = {
            objectType: objectType,
            objectId: objectId,
            userName: userName,
            message: message,
            messageType: messageType,
            sendMail: sendMail,
            mailGroups: mailGroups,
            sendExternalNotification: sendExternalNotification
        };

        let url = `${this.baseServiceUrl}/addObjectHistory`;
        return this.sendRequest(url, payload, 'post');
    }
}
